/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorAIAssistantReceptionTypename = "PharmacyCounselorAIAssistantReception" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorAIAssistantReception
 */
export interface PharmacyCounselorAIAssistantReception {
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorAIAssistantReception
   */
  aiAssistantCounselingId?: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorAIAssistantReception
   */
  counselingId?: number;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorAIAssistantReception
   */
  id?: number;
  /**
   * 残置種別（Aアシ ResumeStatus 由来。came_back_on_same_day 等。null = 残置でない）
   * @type {string}
   * @memberof PharmacyCounselorAIAssistantReception
   */
  resumeStatus?: string;
  /**
   *
   * @type {Date}
   * @memberof PharmacyCounselorAIAssistantReception
   */
  resumeTime?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorAIAssistantReception
   */
  readonly __typename?: string;
}

export function PharmacyCounselorAIAssistantReceptionFromJSON(json: any): PharmacyCounselorAIAssistantReception {
  return PharmacyCounselorAIAssistantReceptionFromJSONTyped(json, false);
}

export function PharmacyCounselorAIAssistantReceptionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorAIAssistantReception {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorAIAssistantReceptionTypename,

    aiAssistantCounselingId: !exists(json, "ai_assistant_counseling_id")
      ? undefined
      : json["ai_assistant_counseling_id"],
    counselingId: !exists(json, "counseling_id") ? undefined : json["counseling_id"],
    id: !exists(json, "id") ? undefined : json["id"],
    resumeStatus: !exists(json, "resume_status") ? undefined : json["resume_status"],
    resumeTime:
      !exists(json, "resume_time") ||
      (typeof json["resume_time"] === "string" && json["resume_time"].substring(0, 4) === "0001")
        ? undefined
        : json["resume_time"],
  };
}

export function PharmacyCounselorAIAssistantReceptionToJSON(
  object?: PharmacyCounselorAIAssistantReception | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    ai_assistant_counseling_id: value.aiAssistantCounselingId,
    counseling_id: value.counselingId,
    id: value.id,
    resume_status: value.resumeStatus,
    resume_time: value.resumeTime === undefined ? undefined : tzDate(value.resumeTime).format(),
  };
}
